import { IS_KALADI_KITCHENS } from "../lib/tenant";

let INTL = {
  CLIENT: 'Client',
  CREW: 'Crew',
  CUSTOMER: 'Customer',
  CUSTOMERS: 'Customers',
  CREW_LIST: 'Crew List',
  DOCUMENTS: 'Documents',
  DOCUMENT: 'Document',
  STATUS_LABEL: 'Status',
  WORK_CALENDAR: 'Work Calendar',
  WORK_GROUP: 'Work Group',
  WORK_TYPE: 'Services',
  WORK_MANAGER: 'Work Manager',
  WORK_ORDER: 'Work Order',
  WORK_ORDERS: 'Work Orders',
  WORK_SCHEDULE: 'Work Schedule',
  TIME_ON_SITE: 'On Site',
  TIME_FROM_SITE: 'Off Site',
  REGISTER: 'Register',
  JOBS: 'Jobs',
  JOB: 'Job',
  VIEWER: 'Viewer'
}

if (IS_KALADI_KITCHENS) {
  INTL = {
    ...INTL,
    CLIENT: 'Tenant',
    CREW: 'Tenant',
    CUSTOMER: 'Tenant',
    CUSTOMERS: 'Tenants',
    CREW_LIST: 'Schedule',
    WORK_CALENDAR: 'Calendar',
    WORK_GROUP: 'Location',
    WORK_TYPE: 'Kitchen',
    WORK_MANAGER: 'Booking Manager',
    WORK_ORDER: 'Booking',
    WORK_ORDERS: 'Bookings',
    TIME_ON_SITE: 'Clock In',
    TIME_FROM_SITE: 'Clock Out',
    REGISTER: 'Inquire',
    JOBS: 'Booking',
    JOB: 'Booking',
    VIEWER: 'Health Inspector'
  };
}

export default INTL;
